/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_TitleInputs */

const vi_sinp_title = /** @type {(inputs: Sinp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PHIẾU NHẬP KHO`)
};

/**

* @param {Sinp_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_title = /** @type {((inputs?: Sinp_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_title(inputs)
});